module.exports = __webpack_public_path__ + "img/header.47d28b39.jpg";